import { render, staticRenderFns } from "./education-list.vue?vue&type=template&id=37fcd8d9&scoped=true&"
import script from "./education-list.vue?vue&type=script&lang=js&"
export * from "./education-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcd8d9",
  null
  
)

export default component.exports